<template>
  <div class="HomeContainer" v-if="$mq == 'desktop'">
    <div class="header-shadow" :style="backgroundStyleHeader()"></div>
    <div class="container">
      <div class="block">
        <div class="title">
          <div class="titleClassF" v-on:click="$router.push('/theme')">
            <a class="icon-visite" v-on:click="$router.push('/theme')">
              <img src="@/assets/visite_noir.png" width="32%" />
            </a>
            <div>{{ $t('home.visit') }}</div>
          </div>
        </div>
        <div class="details">
          <div v-for="theme in globalThemes" :key="theme" class="detailsItems">
            <div :style="backgroundStyle(image(theme))" @click="handleClick(theme.id)" class="tile">
              <div class="titleImage">{{ theme.title }}</div>
              <div class="duration">{{ $t('home.durationStep') }} {{ durationLabel(theme) }}</div>
              <div
                class="downloadBtn"
                @click.prevent="clickInterceptor"
                v-if="offlineStatus != 'no-offline'"
              >
                <download-button
                  ref="download"
                  content-type="theme"
                  :content-id="theme.id"
                  @state-change="handleStateChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="title">
          <div class="titleClassS" v-on:click="$router.push('/listTasting')">
            <a class="icon-bottle" v-on:click="$router.push('/listTasting')">
              <img src="@/assets/bouteille.png" width="8%" />
            </a>
            <div>{{ $t('home.wine') }}</div>
          </div>
        </div>
        <div class="items">
          <div v-for="tasting in this.myTastingList" :key="tasting.id" class="bottle" id="star">
            <tasting-list-item :id="tasting.id" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="header-shadow-mobile" :style="backgroundStyleHeader()"></div>

    <div class="container-mobile">
      <div class="containerChild">
        <div class="titleMobile">
          <div class="titleClassMobile">{{ $t('home.visit') }}</div>
          <div class="showMoreMobile" @click="startVisit">{{ $t('home.seeMore') }} ></div>
        </div>
        <div class="details">
          <div v-for="theme in globalThemes" :key="theme" class="detailsItemsMobile">
            <div
              :style="backgroundStyle(image(theme))"
              @click.self="handleClick(theme.id)"
              class="tileMobile"
            >
              <div
                class="downloadBtn downloadBtnMobile"
                @click.prevent="clickInterceptor"
                v-if="offlineStatus != 'no-offline'"
              >
                <download-button
                  ref="download"
                  content-type="theme"
                  :content-id="theme.id"
                  @state-change="handleStateChange"
                />
              </div>
              <div class="titleImageMobile" @click="handleClick(theme.id)">{{ theme.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="containerChild">
        <div class="titleMobile">
          <div class="titleClassMobile">{{ $t('home.wine') }}</div>
          <div class="showMoreMobile" @click="$router.push({ name: 'listTasting' })">
            {{ $t('home.seeMore') }} >
          </div>
        </div>
        <div class="items">
          <div v-for="tasting in this.myTastingList" :key="tasting.id" class="bottleMobile">
            <tasting-list-item :id="tasting.id" :mini="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import remoteConfig from '@/lib/remote-config'
import { splash_screen_url } from '@/lib/remote-config/constants'

import TastingListItem from '@/components/tasting/TastingListItem'
import { mapGetters } from 'vuex'
import DownloadButton from '@/components/download/DownloadButton'

export default {
  name: 'home',
  components: {
    TastingListItem,
    DownloadButton
  },
  data() {
    return {
      splashUrl: '',
      title: process.env.VUE_APP_TITLE
    }
  },
  computed: {
    ...mapGetters({
      getTastings: 'getTastings',
      getThemes: 'getThemes',
      themeId: 'getThemeById',
      themes: 'themes'
    }),
    remoteConfig() {
      return remoteConfig
    },
    globalThemes() {
      let finalList = []
      const list = this.getThemes.sort((masterclass1, masterclass2) => {
        return masterclass1.order - masterclass2.order
      })
      for (let theme of list) {
        finalList.push(this.themeId(theme.id))
      }
      return finalList
    },
    socialMedia() {
      if (remoteConfig.getValue('social_media')) {
        return JSON.parse(JSON.parse(JSON.stringify(remoteConfig.getValue('social_media'))))
      }
      return []
    },
    myTastingList() {
      let pushElemId = []
      let myTastingList = []
      let themes = this.getThemes.filter(t => t.tastings.length > 0)
      themes.forEach(theme => {
        let tastings = this.getTastings.filter(t =>
          Object.values(_.mapValues(theme.tastings, 'id')).includes(t.id)
        )

        for (let x = 0; x < tastings.length; x += 1) {
          if (pushElemId.indexOf(tastings[x].id) == -1) {
            myTastingList.push(tastings[x])
            pushElemId.push(tastings[x].id)
          }
        }
      })
      return myTastingList
    },

    getStepByTheme() {}
  },
  methods: {
    startVisit() {
      this.$router.push({ name: 'themeList' })
    },

    image(params) {
      return get(params, 'tileImage', null)
    },
    backgroundStyleHeader() {
      return 'background-image: url(' + require('@/assets/background-home.jpg') + ')'
    },
    backgroundStyle(image) {
      return image ? `background: center / cover no-repeat url(${image})` : null
    },
    handleClick() {
      this.$emit('click')
    },
    lessonSteps(params) {
      return params.lessonSteps.map(
        lessonStep => this.$store.state.lesson.lessonStep.byId[lessonStep.id]
      )
    },
    lessons(params) {
      const allLessonIds = this.lessonSteps(params).reduce(
        (accumulator, lessonStep) => [...accumulator, ...lessonStep.lessons],
        []
      )

      return allLessonIds.map(id => this.$store.state.lesson.lesson.byId[id])
    },
    durationLabel(params) {
      const duration = this.lessons(params).reduce((duration, lesson) => {
        if (Number.isSafeInteger(lesson.duration)) return duration + lesson.duration

        return duration
      }, 0)

      const time = this.$tc('masterclass.notice', duration, { duration })
      return time
    },
    handleClick(id) {
      this.$router.push({ name: 'theme', params: { themeId: id } })
    }
  },
  mounted() {
    if (
      window.customSystem &&
      window.customSystem.deferedPrompt &&
      typeof window.customSystem.deferedPrompt.prompt === 'function' &&
      sessionStorage.getItem('promptInstall') === null
    ) {
      window.customSystem.deferedPrompt.prompt()

      sessionStorage.setItem('promptInstall', '1')

      window.customSystem.deferedPrompt = null
    }
    this.splashUrl = remoteConfig.getString(splash_screen_url)
    // this.loading = false
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
.imgd {
  display: block;
  float: left;
  background-color: rgb(26, 39, 14);
  width: 100%;
  height: 400px;
  text-align: center;
}
.header-shadow {
  margin-top: 75px; //for navbar
  width: 100%;
  height: 650px;
  background-attachment: fixed;
}
.header-shadow-mobile {
  width: 100%;
  height: 200px;
  // background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icon-visite {
  margin-right: -50px;
}
.icon-bottle {
  margin-right: -95px;
}

.downloadBtn {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 3;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50px;
  download-button {
    height: 100%;
    width: 100%;
  }
  &:hover {
    box-shadow: -3px -3px 4px #bebebe, 3px 3px 2px #ffffff;
  }
}

.downloadBtnMobile {
  right: 5px;
  top: 5px;
}
.containerChild {
  padding: 10px 0px 0px 10px;
  margin: 10px 10px 10px 10px;
}
.container {
  display: flex;
  flex-direction: column;
  border-radius: 60px 60px 0px 0px;
  background-color: #fff;
  width: 100%;
  height: 100%;
  float: left;
  position: absolute;
  margin-top: -60px;
}
.domaineName {
  font: 'DM Sans' normal 600 43px/50px Friends;
  font-weight: bold;
  font-size: 30px;
  letter-spacing: 0px;
  color: #ffffff;
  text-shadow: 0px 3px 6px #000000;
  position: absolute;
  top: 19%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.imageTile {
  width: 100%;
  height: 200px;
}
.img {
  display: flex;
  float: left;
  background-color: rgb(26, 39, 14);
  width: 100%;
  height: 200px;
  justify-content: center;
  text-align: center;
  align-items: center;
}
.goto {
  color: #ffffff;
  background: $primary 0% 0% no-repeat padding-box;
  border-radius: 18px;
  padding: 5px;
  box-shadow: 2px 2px 6px #000000;
}
.durationMobile {
  font: normal normal 600 12px Friends;
  letter-spacing: 0px;
  color: #ffffff;
  text-shadow: 0px 3px 6px #000000;
}
.duration {
  font: normal normal normal 18px Helvetica;
  letter-spacing: 0px;
  color: #ffffff;
  text-shadow: 0px 3px 6px #000000;
}
.titleImageMobile {
  font: normal normal bold 15px Helvetica;
  letter-spacing: 0px;
  color: #ffffff;
  text-shadow: 0px 3px 6px #000000;
  text-align: center;
}
.titleImage {
  font: normal normal bold 25px Helvetica;
  letter-spacing: 0px;
  color: #ffffff;
  text-shadow: 0px 3px 6px #000000;
  text-align: center;
}
.tileMobile {
  width: 140px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 13px;
  flex-direction: column;
  cursor: pointer;
}
.tile {
  min-width: 300px;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  flex-direction: column;
  cursor: pointer;
  transition: opacity 0.2s linear;
}
.tile:hover {
  opacity: 0.84;
  cursor: pointer;
}

// .tile:hover span {
//   display: none;
//   // width: 450px;
//   // height: 250px;
//   // display: flex;
//   // align-items: center;
//   // justify-content: space-evenly;
//   // border-radius: 48px;
//   // flex-direction: column;
//   // cursor: pointer;
// }
// .tile:hover:before {
//   font: normal normal 600 40px/50px Friends;
//   letter-spacing: 0px;
//   color: #FFFFFF;
//   text-shadow: 0px 3px 6px #000000;
//   text-align: center;
//   background: black;
//   content: "TEST"
// }
.details {
  display: flex;
  flex-direction: row;
  overflow-y: scroll;
  margin: 20px 0px;
  overflow: auto;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.details::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.details {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.detailsItemsMobile {
  width: 140px;
  height: 150px;
  margin: 10px;
  position: relative;
}
.detailsItems {
  width: 350px;
  height: 250px;
  margin: 10px;
  border-radius: 25px;
  background: #000000;
  position: relative;
}
.bottleMobile {
  height: 170px;
  width: 230px;
  background: #e3e3e3 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #b0b4cb;
  border-radius: 10px;
  margin: 10px 10px;
  padding: 10px;
}
.bottle {
  background: #e3e3e3 0% 0% no-repeat padding-box;
  border-radius: 48px;
  margin: 10px 10px;
  padding: 15px;
}
.items::-webkit-scrollbar {
  display: none;
}
.items {
  display: flex;
  flex-direction: row;
  overflow-y: scroll;
  margin: 30px 0px;
  height: 300px;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.items::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.items {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.block {
  display: flex;
  flex-direction: column;
  padding: 25px 5px 0 25px;
  padding-top: 75px;
}
.title {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.titleMobile {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0 10px;
}
.showMoreMobile {
  font: normal normal normal 13px/15px Friends;
  letter-spacing: 0px;
  color: #767676;
  text-align: center;
  margin-left: 50px;
  margin-top: 10px;
  cursor: pointer;
}
.showMore {
  font: normal normal normal 20px/18px Friends;
  letter-spacing: 0px;
  color: #767676;
  text-align: center;
  margin-left: 50px;
  margin-top: 10px;
  cursor: pointer;
}
.titleClassF {
  display: flex;
  justify-content: flex-end;
  // font: normal normal 800 21px/29px Friends;
  text-transform: uppercase;
  font: normal normal bold 25px $font-family-app;
  color: #404040;
  letter-spacing: 0px;
  color: $primary;
  border: $primary solid 2px;
  margin-left: -35px;
  width: 60%;
  padding: 10px;
  cursor: pointer;
  align-items: center;
}

.titleClassS {
  display: flex;
  justify-content: flex-start;
  // font: normal normal 800 21px/29px Friends;
  text-transform: uppercase;
  font: normal normal bold 25px $font-family-app;
  color: #404040;
  letter-spacing: 0px;
  color: $primary;
  border: $primary solid 2px;
  margin-left: 40%;
  width: 70%;
  padding: 5px;
  cursor: pointer;
  align-items: center;
  margin-right: (-5px);
  border-right-style: none;
}
.titleClassMobile {
  // font: normal 800 21px/29px Friends;
  font: normal normal bold 21px $font-family-app;
  font-weight: bold;
  letter-spacing: 0px;
  color: $primary;
}

.card—center {
  margin-left: auto !important;
  margin-right: auto !important;
}

.Col2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  row-gap: 5px;

  & .item {
    width: 50%;

    &:first-child {
      margin-right: 2.5px;
    }

    &:last-child {
      margin-left: 2.5px;
    }
  }
}

.Desktop-Container {
  .Desktop-Card {
    display: inline-block;
    max-width: none;
    width: 49.5%;

    &:not(.Full):nth-of-type(2n) {
      margin-right: 1%;
    }

    &.Full {
      width: 100%;
    }
  }
}
.list-social-media {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 20px;

  .item-social-media {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 10px;
    margin-right: 10px;
    .asset-rrecommendations {
      flex-direction: row;
    }

    img {
      width: 25px;
      height: 25px;
    }
  }
}
</style>
